<template>
  <div class="imgBox min-w-1400">
    <div class="imgBox1 min-w-1400">
      <div class="img1 max-w-1400">
        <p class="imgItem1">ศูนย์ปัญหา</p>
        <!-- <img :src="importedImg1" :alt="altText" class="imgItem1" /> -->
      </div>
    </div>
    <div class="imgBox2 min-w-1400">
      <div class="img2 max-w-1400">
        <!-- <h1>Cam kết bảo mật</h1> -->
        <!-- <div class="title-line"></div> -->
        <div class="textBox" style="white-space: pre-wrap">{{ text }}</div>
      </div>
    </div>
  </div>
</template>

<script>
// import importedImg1 from "@/page/passmorecompany/components/img/4_1.png";

export default {
  data() {
    return {
      altText: "protocolTitle",
      // importedImg1: importedImg1,
      text: `ไม่ว่าในกรณีใด หน่วยงานเหล่านี้จะอยู่ภายใต้ภาระหน้าที่ในการรักษาความลับในการจัดการข้อมูลอย่างเท่าเทียมกันโดยมีข้อจำกัดทางกฎหมายที่กำหนดโดยกฎหมายที่บังคับใช้ในเรื่องนี้ ในเขตอำนาจศาลที่ข้อมูลนั้นถูกรวบรวม เก็บถาวร ประมวลผล หรือส่งต่อ
ข้อมูลส่วนบุคคลจะไม่ถูกใช้หรือประมวลผลเพื่อวัตถุประสงค์อื่นนอกเหนือจากที่ระบุไว้ที่นี่

เราจะใช้ข้อมูลส่วนบุคคลของคุณเพื่อวัตถุประสงค์อะไร?
ข้อมูลส่วนบุคคลที่เรารวบรวมโดยตรงจากคุณหรือผ่านบุคคลที่สามจะถูกใช้เพื่อวัตถุประสงค์ต่อไปนี้ซึ่งจำเป็นสำหรับบริการที่คุณร้องขอ:
• การปฏิบัติตามความสัมพันธ์ตามสัญญาที่ได้มาจากคำขอและ/หรือการทำสัญญาของบริการ
• จัดการ ดำเนินการ และตรวจสอบบริการที่คุณร้องขอหรือทำสัญญา
• ดำเนินการวิเคราะห์ข้อมูลที่เจ้าของให้ไว้ เพื่อกำหนดระดับความเสี่ยง ความมีชีวิตในการชำระเงิน ประวัติการทำธุรกรรม และการประเมินอื่น ๆ ตามข้อกำหนดทางกฎหมายในปัจจุบันตามที่กำหนดในการให้บริการ .
• จัดทำความสัมพันธ์ตามสัญญาระหว่างเรากับเจ้าของอย่างเป็นทางการ
• รวมไว้ในฐานข้อมูลของเรา รวมไฟล์ โดยตรงหรือผ่านบุคคลที่สาม
• ดำเนินการตามคำขอของคุณผ่านสื่ออิเล็กทรอนิกส์ของเรา
• สร้างโปรไฟล์ของคุณในฐานะผู้ใช้ในแอป
• ปรึกษาและดำเนินการตรวจสอบเครดิตกับบริษัทข้อมูลเครดิตที่คุณเห็นว่าเหมาะสม
• เสนอการขยายหรือปรับปรุงบริการตามสัญญา
• แจ้งการอัพเดตบริการ
• เพื่อปฏิบัติตามภาระผูกพันของเราที่มีอยู่ในกฎหมายที่บังคับใช้
• ส่งการแจ้งเตือนทุกประเภทผ่านวิธีการใด ๆ เพื่อให้สอดคล้องกับภาระผูกพันของคุณที่เกิดขึ้นจากคำขอหรือสัญญาที่ทำขึ้นระหว่างเราและเจ้าของ
• ในกรณีที่ไม่ปฏิบัติตามภาระผูกพันของเจ้าของ โดยเฉพาะอย่างยิ่งการชำระเงิน ให้ติดต่อข้อมูลอ้างอิงที่เจ้าของให้ไว้ เพื่อรับข้อมูลติดต่อใหม่ของเจ้าของ โดยไม่ต้องดำเนินการหรือจัดการคอลเลกชันใด ๆ ด้วยการอ้างอิงข้างต้น
• ดำเนินการข่าวกรองเชิงพาณิชย์ ดำเนินการวิจัยตลาด ให้การมองเห็นกิจกรรมของคุณในสื่ออิเล็กทรอนิกส์ของเรา การตรวจสอบคุณภาพของสื่ออิเล็กทรอนิกส์ของเรา การประเมินผลและการปรับปรุงสื่ออิเล็กทรอนิกส์ของเรา
นอกจากนี้ เราจะใช้ข้อมูลส่วนบุคคลของคุณเพื่อวัตถุประสงค์รองต่อไปนี้ซึ่งไม่จำเป็นสำหรับบริการที่ร้องขอ แต่อนุญาตและอำนวยความสะดวกให้เราให้บริการที่ดีกว่าแก่คุณได้:
• การส่งโฆษณา การตลาดทางโทรศัพท์ การตลาด ข้อเสนอ โปรโมชั่น จดหมายข่าว และข้อเสนอพิเศษหรือกิจกรรมที่เจ้าของอาจสนใจ เช่นเดียวกับบริการหรือผลิตภัณฑ์ที่นำเสนอโดยพันธมิตรทางการค้า
• การตลาดหรือการโฆษณา
• การสำรวจแร่เชิงพาณิชย์
หากคุณไม่ต้องการให้ข้อมูลส่วนตัวของคุณถูกประมวลผลเพื่อวัตถุประสงค์รองเหล่านี้ คุณสามารถแจ้งให้เราทราบถึงเรื่องข้างต้นผ่านกลไกต่อไปนี้:
การปฏิเสธที่จะใช้ข้อมูลส่วนบุคคลของคุณเพื่อวัตถุประสงค์เหล่านี้อาจไม่ใช่เหตุผลที่เราปฏิเสธบริการและผลิตภัณฑ์ที่คุณร้องขอหรือทำสัญญากับเรา
การประมวลผลข้อมูลโดยไม่มีการตัดสินใจเชิงประเมินโดยมนุษย์
เราแจ้งให้คุณทราบว่า เพื่อให้เป็นไปตามวัตถุประสงค์ที่กำหนดไว้ในประกาศความเป็นส่วนตัวนี้ เราจะประมวลผลข้อมูลส่วนบุคคลโดยเป็นส่วนหนึ่งของกระบวนการตัดสินใจโดยไม่มีการแทรกแซงของมนุษย์ในการให้เครดิต ซึ่งเกี่ยวข้องกับการใช้บริการด้วย เพื่อให้เป็นไปตามวัตถุประสงค์บางประการที่รายงานในประกาศความเป็นส่วนตัวนี้
เราจะใช้ข้อมูลส่วนบุคคลใดเพื่อวัตถุประสงค์เหล่านี้
เพื่อดำเนินการตามวัตถุประสงค์ที่อธิบายไว้ในประกาศความเป็นส่วนตัวนี้ เราจะใช้ข้อมูลส่วนบุคคลต่อไปนี้:
• ข้อมูลประจำตัว
• ข้อมูลติดต่อ
• ข้อมูลเกี่ยวกับลักษณะทางกายภาพ
• ข้อมูลไบโอเมตริกซ์
• ข้อมูลแรงงาน
• ข้อมูลทางวิชาการ
• สินทรัพย์และ/หรือข้อมูลทางการเงิน
นอกเหนือจากข้อมูลส่วนบุคคลที่กล่าวถึงข้างต้น เพื่อวัตถุประสงค์ที่รายงานในประกาศความเป็นส่วนตัวนี้ เราจะใช้ข้อมูลส่วนบุคคลต่อไปนี้ซึ่งถือว่าละเอียดอ่อนซึ่งต้องมีการคุ้มครองเป็นพิเศษ:
• ข้อมูลไบโอเมตริกซ์
การถ่ายโอนข้อมูลส่วนบุคคล
เราจะไม่ถ่ายโอนข้อมูลส่วนบุคคลไปยังบุคคลธรรมดาหรือนิติบุคคลที่ไม่ได้เป็นของเราหรือบริษัทในเครือหรือบุคคลที่สามที่ไม่ได้เข้าร่วมในบริการที่มอบให้เรา
เจ้าของตกลงว่าเราจะแบ่งปันข้อมูลส่วนบุคคลของคุณกับ: (i) บริษัทที่ควบคุม บริษัทย่อย หรือบริษัทในเครือที่อยู่ภายใต้การควบคุมเดียวกันกับเรา เช่นเดียวกับบริษัทแม่ของเราหรือบริษัทใด ๆ ในกลุ่มบริษัทของเราที่ดำเนินงานภายใต้กระบวนการและนโยบายภายในเดียวกัน , (ii) กับหน่วยงานผู้มีอำนาจ หากได้รับการร้องขอ ในแง่ของกฎหมายที่ใช้บังคับ (iii) กับสมาคมข้อมูลเครดิตที่เราได้ทำสัญญาด้วย (iv) สมาคมหรือบริษัทที่รับผิดชอบในการรวบรวมและเรียกเก็บเงิน (v) ) กับบริษัทอื่น ๆ ในกรณีที่บริษัทนั้นเข้าซื้อกิจการ ควบรวมกิจการ หรือดำเนินการอื่นใดที่คล้ายคลึงกัน (vi) กับบริษัทอื่น ๆ ที่ให้บริการโครงสร้างพื้นฐานและ/หรือบริการสำหรับการให้บริการแก่เรา (ผู้ประมวลผล) (vii) บุคคลที่สาม รวมถึงหน่วยงานทางการเงินสำหรับการกำหนดหรือลดพอร์ตสินเชื่อการรับรองหรือรูปแบบอื่น ๆ ของการเจรจาพอร์ตสินเชื่อ (viii) พันธมิตรทางธุรกิจที่ทำสัญญาด้วย สำหรับการตลาดผลิตภัณฑ์และ / หรือบริการสำหรับ ประโยชน์ของเจ้าของ และ (ix) ในกรณีอื่นใดที่กำหนดไว้ในมาตรา 10 และ 37 ของกฎหมาย
การโอนระหว่างประเทศ
เจ้าของยอมรับว่าข้อมูลของพวกเขาจะถูกแบ่งปันและถ่ายโอนมาให้เราและประมวลผลนอกประเทศ หากจำเป็นสำหรับวัตถุประสงค์ที่กล่าวถึงในย่อหน้าก่อนหน้า ดังนั้นจึงเป็นเรื่องสำคัญที่คุณต้องทราบว่าข้อมูลของคุณได้รับการคุ้มครองโดยอาศัยข้อเท็จจริงที่ว่าหากจำเป็นต้องส่งข้อมูลของคุณ บริษัทเหล่านี้ จะดำเนินการภายใต้นโยบายคุ้มครองข้อมูลส่วนบุคคลเดียวกันและยังมีนโยบายความเป็นส่วนตัวด้วย และความเป็นส่วนตัว
เราจะสื่อสารประกาศความเป็นส่วนตัวนี้ไปยังผู้รับ เพื่อให้แน่ใจว่าข้อมูลของพวกเขาจะถูกนำไปใช้ตามข้อกำหนด
การใช้สิทธิ ARCO
คุณจะเข้าถึง แก้ไข หรือยกเลิกข้อมูลส่วนบุคคลของคุณ หรือคัดค้านการใช้งานได้อย่างไร?
คุณมีสิทธิ์ที่จะทราบว่าเรามีข้อมูลส่วนบุคคลใดบ้างเกี่ยวกับคุณ เราใช้ข้อมูลนั้นเพื่ออะไร และเงื่อนไขการใช้งานที่เรามอบให้ (การเข้าถึง) ในทำนองเดียวกัน เป็นสิทธิ์ของคุณที่จะขอแก้ไขข้อมูลส่วนบุคคลของคุณหากข้อมูลนั้นล้าสมัย ไม่ถูกต้องหรือไม่สมบูรณ์ (การแก้ไข) ที่เราลบออกจากบันทึกหรือฐานข้อมูลของเราเมื่อเราพิจารณาว่ามีการใช้ไม่เหมาะสม (การยกเลิก) พร้อมทั้งคัดค้านการใช้ข้อมูลส่วนบุคคลของคุณเพื่อวัตถุประสงค์เฉพาะ (ฝ่ายค้าน) สิทธิ์เหล่านี้เรียกว่าสิทธิ์ ARCO
หากต้องการใช้สิทธิ์ ARCO ใด ๆ คุณต้องส่งคำขอที่เกี่ยวข้องผ่านวิธีการดังต่อไปนี้:
ผ่านทางอีเมล์
เกี่ยวกับขั้นตอนและข้อกำหนดในการใช้สิทธิ์ ARCO ของคุณ เราแจ้งให้คุณทราบดังต่อไปนี้:
ก) เจ้าของและตัวแทนของเขา รวมทั้งบุคลิกภาพของเจ้าของสามารถพิสูจน์ตัวตนของพวกเขาได้ด้วยวิธีใด
ผ่านสำเนาบัตรประจำตัวอย่างเป็นทางการของคุณ (หนังสือรับรองการลงคะแนนเสียงที่ออกโดย INE)
b) ใบสมัครควรมีข้อมูลและ/หรือเอกสารอะไรบ้าง?
• ชื่อและที่อยู่หรือวิธีการอื่นในการสื่อสารการตอบสนองต่อคำขอของคุณ รวมถึงเอกสารที่พิสูจน์ตัวตนของคุณหรือตัวแทนทางกฎหมาย หากมี
• องค์ประกอบหรือเอกสารอื่นใดที่เอื้อต่อตำแหน่งของข้อมูลส่วนบุคคล
• คำขอจะต้องลงนามที่ส่วนท้ายของเอกสารและมีชื่อย่อที่ด้านล่างของแต่ละหน้า
• คำอธิบายที่ชัดเจนและแม่นยำของข้อมูลส่วนบุคคลที่คุณต้องการใช้สิทธิ์ ARCO รวมถึงสิทธิ์หรือสิทธิ์ที่คุณต้องการใช้ซึ่งอาจทำได้ในข้อความอีเมลหรือในการสแกนและแนบ เอกสาร ลงนามรับรองสำเนาถูกต้องที่ส่วนท้ายของเอกสารและมีอักษรย่อที่ด้านล่างของแต่ละหน้า
• ในกรณีของการร้องขอให้แก้ไขข้อมูลส่วนบุคคล เจ้าของจะต้องระบุนอกเหนือจากที่ระบุไว้ การเปลี่ยนแปลงที่ต้องทำ และจัดเตรียมเอกสารที่สนับสนุนคำขอของพวกเขา
c) เราจะตอบกลับคำขอของคุณภายในกี่วัน?
ภายใน 20 (ยี่สิบ) วันทำการ
d) เราจะสื่อสารการตอบสนองต่อคำขอของคุณโดยวิธีใด?
ทางอีเมลที่เจ้าของให้ไว้ผ่านแอพมือถือ
จ) ข้อมูลส่วนบุคคลที่คุณร้องขอสามารถทำซ้ำได้ในสื่อใด?
ผ่านแอพมือถือ
การเพิกถอนความยินยอม
คุณสามารถเพิกถอนความยินยอมในการใช้ข้อมูลส่วนบุคคลของคุณได้
คุณสามารถเพิกถอนความยินยอมที่คุณมอบให้เราในการประมวลผลข้อมูลส่วนบุคคลของคุณได้ (ถ้ามี) อย่างไรก็ตาม สิ่งสำคัญคือคุณต้องจำไว้ว่าไม่ใช่ในทุกกรณีที่เราจะสามารถตอบสนองต่อคำขอของคุณหรือยุติการใช้งานได้ทันที เนื่องจากเป็นไปได้ว่าเนื่องจากภาระผูกพันทางกฎหมายบางประการ เราจึงจำเป็นต้องดำเนินการประมวลผลข้อมูลส่วนบุคคลของคุณต่อไป ในทำนองเดียวกัน คุณต้องพิจารณาว่าสำหรับวัตถุประสงค์บางประการ การเพิกถอนความยินยอมของคุณจะหมายความว่าเราจะไม่สามารถให้บริการที่คุณร้องขอจากเราต่อไปได้ หรือยุติความสัมพันธ์ของคุณกับเรา
เกี่ยวกับขั้นตอนและข้อกำหนดในการเพิกถอนความยินยอมของคุณ เราจะแจ้งให้คุณทราบดังต่อไปนี้:
ก) เจ้าของและตัวแทนของเขา รวมทั้งบุคลิกภาพของเจ้าของสามารถพิสูจน์ตัวตนของพวกเขาได้ด้วยวิธีใด
ผ่านสำเนาบัตรประจำตัวอย่างเป็นทางการของคุณ (หนังสือรับรองการลงคะแนนเสียงที่ออกโดย INE) หรือเอกสารที่คุณพิสูจน์เป็นตัวแทนทางกฎหมายของคุณหากคุณไม่ใช่ผู้ถือ
b) ใบสมัครควรมีข้อมูลและ/หรือเอกสารอะไรบ้าง?
• ชื่อและที่อยู่หรือวิธีการอื่นในการสื่อสารการตอบสนองต่อคำขอของคุณ รวมถึงเอกสารที่พิสูจน์ตัวตนของคุณหรือตัวแทนทางกฎหมาย หากมี
• องค์ประกอบหรือเอกสารอื่นใดที่เอื้อต่อตำแหน่งของข้อมูลส่วนบุคคล
• คำขอจะต้องลงนามที่ส่วนท้ายของเอกสารและมีชื่อย่อที่ด้านล่างของแต่ละหน้า
c) เราจะตอบกลับคำขอของคุณภายในกี่วัน?
20 (ยี่สิบ) วันทำการ
d) เราจะสื่อสารการตอบสนองต่อคำขอของคุณโดยวิธีใด?
อีเมลที่เจ้าของให้ไว้ผ่านแอพมือถือ
ในทำนองเดียวกัน คุณสามารถลงทะเบียนสำหรับการลงทะเบียนต่อไปนี้ ในกรณีที่คุณไม่ต้องการรับโฆษณาจากเรา:
ทะเบียนสาธารณะของผู้ใช้ สำหรับข้อมูลเพิ่มเติม โปรดดูที่เว็บไซต์ของ
คอนดัเซฟ
คุณจะทราบเกี่ยวกับการเปลี่ยนแปลงประกาศความเป็นส่วนตัวนี้ได้อย่างไร
ประกาศความเป็นส่วนตัวนี้อาจได้รับการแก้ไข เปลี่ยนแปลง หรืออัปเดตเนื่องจากข้อกำหนดทางกฎหมายใหม่ ความต้องการของเราเองสำหรับผลิตภัณฑ์หรือบริการที่เรานำเสนอ ของแนวทางปฏิบัติด้านความเป็นส่วนตัวของเรา การเปลี่ยนแปลงในรูปแบบธุรกิจของเราหรือสาเหตุอื่น ๆ
เรามุ่งมั่นที่จะแจ้งให้คุณทราบเกี่ยวกับการเปลี่ยนแปลงใด ๆ ที่อาจเกิดขึ้นจากประกาศความเป็นส่วนตัวนี้ ผ่านทาง: เว็บไซต์และแอพมือถือ
ขั้นตอนที่การแจ้งเตือนเกี่ยวกับการเปลี่ยนแปลงหรือการปรับปรุงประกาศความเป็นส่วนตัวนี้จะดำเนินการดังต่อไปนี้:
การเปลี่ยนแปลงประกาศความเป็นส่วนตัวจะแจ้งให้เจ้าของทราบผ่านทางเว็บไซต์และแอพมือถือ เจ้าของอาจแสดงการปฏิเสธของเขา/เธอเกี่ยวกับการเปลี่ยนแปลงโดยส่งอีเมลถึงเรา ตราบใดที่คำขอนั้นเป็นไปได้ มิฉะนั้นสถานการณ์จะเกิด และอุปสรรคทางกฎหมายจะแจ้งให้คุณทราบ หากการเปลี่ยนแปลงต้องได้รับความยินยอมอย่างชัดแจ้งจากเจ้าของ จะมีการร้องขอผ่านแอพมือถือ
รายชื่อติดต่อใช้เพื่อยืนยันข้อมูลของคุณและติดต่อคุณในกรณีฉุกเฉินเท่านั้น ข้อมูลสินเชื่อจะไม่ถูกแชร์
ในอัตราผิดนัดจะมีข้อจำกัดภายในอัตราเหล่านี้ เพื่อไม่ให้เกินเปอร์เซ็นต์หนึ่งของจำนวนเงินที่ยืม`,
    };
  },
};
</script>

<style scoped>
.imgBox {
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
}

.imgBox1 {
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 1400px;
  background-color: "";
}

.imgBox2 {
  display: flex;
  justify-content: center;
  max-width: 1400px;
  padding-top: 40px;
  padding-bottom: 20px;
  height: 3700px;
  background-color: #ffffff;
  border-radius: 32px;
  margin: -140px auto 150px;
}

.imgBox3 {
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 1400px;
  background-color: "";
}

img {
  display: block;
}

.img1 {
  overflow: hidden;
  width: 100%;
}

.img2,
.img4 {
  overflow: hidden;
}

.img3 {
  width: 100%;
  overflow: hidden;
  margin-left: 0;
  margin-right: 0;
}

.imgItem1 {
  width: 100%;
  margin-top: 0;
  margin-bottom: 0;
}

.imgItem2 {
  max-width: 100%;
}

.imgItem3 {
  width: 100%;
  overflow: hidden;
  margin-left: 0;
  margin-right: 0;
}

h1 {
  margin-top: 50px;
  margin-left: 490px;
  color: #3f4842;
  font-size: 40px;
  /* border-bottom: 5px solid #04358A; */
  display: inline-block;
}

.textBox {
  margin-top: 50px;
  margin-left: 100px;
  margin-right: 100px;
  font-size: 18px;
  color: #333333;
}

.imgBox2 {
  transform: scale(90%);
  /* transform: scale(80%); */
  margin: -150px auto 100px;
  height: 3100px;
  /* box-shadow: 0 1px 4.8px 0px rgba(0, 0, 0, 0.25); */
  /* border: 2px solid #4D64E4; */
  border-radius: 36px;
  /* border-top: 1px solid #457b9d;
  border-bottom: 1px solid #457b9d; */
}
.textBox {
  margin-top: 20px;
  margin-left: 50px;
  margin-right: 50px;
}
/* .imgBox2{
  border-radius: 0;
  border-top: 3px solid #7c2af8;
  border-left: 2px solid #e9e9e9;
  border-right: 2px solid #e9e9e9;
  border-bottom: 3px solid #c1c1c1;
} */
.title-line {
  width: 430px;
  /* background: url(./components/img/Group1.png); */
  /* background-repeat: no-repeat; */
  /* background-position: -150px 10px; */
  /* height: 50px; */
  /* border: 1px solid red; */
  border: 2px solid #4d64e4;
  margin: 0 500px;
}

.img1 {
  /* background: radial-gradient(57.03% 57.03% at 50% 50%, #3C51A0 0%, #223479 100%); */
  height: 291px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.imgItem1 {
  color: #333333;
  font-family: "Thonburi";
  font-weight: 700;
  font-size: 34px;
  text-align: center;
}
</style>
